<div class="modal-content-custom">
    <div class="modal-header-custom" style="flex-shrink: 0;">
        <div>
            <h5 class="modal-title-custom">
                <span *ngIf="!data?.isEditMode && !data?.prefillFromDirectory">Contribute New Contact</span>
                <span *ngIf="data?.isEditMode || data?.prefillFromDirectory">Edit Record</span>
            </h5>
            <p class="modal-subtitle" *ngIf="!data?.isEditMode && !data?.prefillFromDirectory">
                Help us keep the directory updated and earn credits after verification.
            </p>
            <p class="modal-subtitle" *ngIf="data?.isEditMode">Update the contribution details below.</p>
            <p class="modal-subtitle modal-subtitle-muted" *ngIf="data?.prefillFromDirectory && !data?.isEditMode">
                Update the nodal officer contact details.
            </p>
        </div>
        <button type="button" class="close-btn" (click)="closeDialog()">
            ×
        </button>
    </div>

    <div class="modal-body-custom" style="flex: 1; overflow-y: auto;">
        <div class="verification-note" *ngIf="!data?.prefillFromDirectory">
            <i class="fas fa-info-circle info-icon"></i>
            <span>
                Your submission will be reviewed by the admin. You'll earn credits once verified.
            </span>
        </div>

        <form id="contactForm" (submit)="onSubmit($event)" novalidate>
            <div class="form-group-custom">
                <label for="name" class="form-label">Nodal Officer Name <span class="required">*</span></label>
                <input type="text" class="form-control dark-input" [class.error]="errors.name" id="name" [(ngModel)]="formData.name" name="name" required (blur)="onFieldBlur('name')" (input)="onFieldInput('name')" maxlength="100" placeholder="Enter officer name">
                <div class="error-message" *ngIf="errors.name">{{ errors.name }}</div>
            </div>

            <div class="form-group-custom">
                <label for="email" class="form-label">Email <span class="required">*</span></label>
                <input type="text" class="form-control dark-input" [class.error]="errors.email" id="email" [(ngModel)]="formData.email" name="email" (blur)="onFieldBlur('email')" (input)="onEmailInput($event)" placeholder="Multiple emails separated by comma">
                <div class="error-message" *ngIf="errors.email">{{ errors.email }}</div>
            </div>

            <div class="form-group-custom">
                <label for="phone" class="form-label">Mobile Number <span class="required">*</span></label>
                <div class="phone-input-group" [class.error]="errors.phone">
                    <select class="country-select" [(ngModel)]="selectedCountryCode" name="countryCode">
                        <option *ngFor="let country of countries" [value]="country.dialCode">
                            {{ country.flag }} {{ country.dialCode }}
                        </option>
                    </select>
                    <input type="tel" class="form-control dark-input phone-input" id="phone" [ngModel]="formData.phone" name="phone" (blur)="onFieldBlur('phone')" (input)="onPhoneInput($event)" (keypress)="onPhoneKeyPress($event)" placeholder="Multiple numbers separated by comma">
                </div>
                <div class="error-message" *ngIf="errors.phone">{{ errors.phone }}</div>
            </div>

            <div class="form-group-custom">
                <label for="address" class="form-label">Address <span class="required">*</span></label>
                <input type="text" class="form-control dark-input" [class.error]="errors.address" id="address" [(ngModel)]="formData.address" name="address" required (blur)="onFieldBlur('address')" (input)="onFieldInput('address')" maxlength="200" placeholder="Enter address">
                <div class="error-message" *ngIf="errors.address">{{ errors.address }}</div>
            </div>

            <div class="form-group-custom">
                <label for="operator" class="form-label">Operator Name <span class="required">*</span></label>
                <input type="text" class="form-control dark-input" [class.error]="errors.operator" id="operator" [(ngModel)]="formData.operator" name="operator" required (blur)="onFieldBlur('operator')" (input)="onFieldInput('operator')" maxlength="100" placeholder="Enter operator/organization name">
                <div class="error-message" *ngIf="errors.operator">{{ errors.operator }}</div>
            </div>

            <div class="form-group-custom">
                <label for="operator_type" class="form-label">Operator Type <span class="required">*</span></label>
                <select class="form-control dark-input" [class.error]="errors.operator_type" id="operator_type" [(ngModel)]="formData.operator_type" name="operator_type" required (blur)="onFieldBlur('operator_type')" (change)="onFieldInput('operator_type')">
                    <option value="">Select Operator Type</option>
                    <option *ngFor="let operatorType of operatorTypes" [value]="getOperatorTypeValue(operatorType)">
                        {{ getOperatorTypeName(operatorType) }}
                    </option>
                </select>
                <div class="error-message" *ngIf="errors.operator_type">{{ errors.operator_type }}</div>
            </div>

            <div class="form-group-custom">
                <label class="form-label">Operator Logo (optional)</label>
                <div class="contributor-image-upload" (click)="operatorLogoInput.click()" (dragover)="$event.preventDefault(); isOperatorLogoDragOver = true" (dragleave)="isOperatorLogoDragOver = false" (drop)="$event.preventDefault(); isOperatorLogoDragOver = false; onOperatorLogoDrop($event)" [class.drag-over]="isOperatorLogoDragOver">
                    <input #operatorLogoInput type="file" class="contributor-image-input" [accept]="CONTRIBUTOR_IMAGE_ACCEPT" (change)="onOperatorLogoChange($event)" />
                    <ng-container *ngIf="!operatorLogoPreview; else operatorLogoPreviewBlock">
                        <i class="fas fa-cloud-upload-alt upload-icon"></i>
                        <span class="upload-text">Choose logo or drag and drop</span>
                        <span class="upload-hint">PNG, JPG, WebP, GIF up to 2MB</span>
                    </ng-container>
                    <ng-template #operatorLogoPreviewBlock>
                        <div class="contributor-image-preview-wrap">
                            <img [src]="operatorLogoPreview" alt="Operator logo" class="contributor-image-preview" />
                            <span class="upload-change">Change logo</span>
                        </div>
                    </ng-template>
                </div>
                <div class="error-message" *ngIf="errors.operatorLogo">{{ errors.operatorLogo }}</div>
            </div>

            <div
                class="form-group-custom"
                *ngIf="data?.isEditMode && data?.submissionId"
            >
                <label for="request_reason" class="form-label">
                    Reason for Update <span class="required">*</span>
                </label>
                <textarea
                    class="form-control dark-input"
                    [class.error]="errors.request_reason"
                    id="request_reason"
                    [(ngModel)]="formData.request_reason"
                    name="request_reason"
                    rows="4"
                    required
                    (blur)="onFieldBlur('request_reason')"
                    (input)="onFieldInput('request_reason')"
                    placeholder="Enter reason for this update request"
                ></textarea>
                <div class="error-message" *ngIf="errors.request_reason">{{ errors.request_reason }}</div>
            </div>

            <div class="form-section">
                <h6 class="form-section-title">Contributor details</h6>
                <div class="form-group-custom">
                    <label for="friendly_name" class="form-label">Display Name<span class="required">*</span></label>
                    <input type="text" class="form-control dark-input" [class.error]="errors.friendly_name" id="friendly_name" [(ngModel)]="formData.friendly_name" name="friendly_name" required (blur)="onFieldBlur('friendly_name')" (input)="onFieldInput('friendly_name')" maxlength="100" placeholder="Your display name">
                    <div class="error-message" *ngIf="errors.friendly_name">{{ errors.friendly_name }}</div>
                </div>
                <div class="form-group-custom">
                    <label class="form-label">Display Photo</label>
                    <div class="contributor-image-upload" (click)="contributorImageInput.click()" (dragover)="$event.preventDefault(); isDragOver = true" (dragleave)="isDragOver = false" (drop)="$event.preventDefault(); isDragOver = false; onContributorImageDrop($event)" [class.drag-over]="isDragOver">
                        <input #contributorImageInput type="file" class="contributor-image-input" accept="image/jpeg,image/png,image/webp,image/gif" (change)="onContributorImageChange($event)" />
                        <ng-container *ngIf="!contributorImagePreview; else previewBlock">
                            <i class="fas fa-cloud-upload-alt upload-icon"></i>
                            <span class="upload-text">Choose file or drag and drop</span>
                            <span class="upload-hint">PNG, JPG, WebP, GIF up to 2MB</span>
                        </ng-container>
                        <ng-template #previewBlock>
                            <div class="contributor-image-preview-wrap">
                                <img [src]="contributorImagePreview" alt="Contributor" class="contributor-image-preview" />
                                <span class="upload-change">Change image</span>
                            </div>
                        </ng-template>
                    </div>
                    <div class="error-message" *ngIf="errors.contributorImage">{{ errors.contributorImage }}</div>
                </div>
            </div>

            <button type="submit" class="btn btn-submit-custom" [disabled]="isSubmitting || !isFormValid()">
                <span *ngIf="!isSubmitting">Submit for Verification</span>
                <span *ngIf="isSubmitting">Submitting...</span>
            </button>
        </form>
    </div>
</div>